/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {
  FETCH_SUBSCRIPTIONS,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE,

  UNSUBSCRIBE,
  UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_FAILURE,

} from './action-types.js';

import {
  ACTIVATE_SUCCESS,
} from 'modules/subscription-management/action-types.js';


import { Subscription } from './types.js';

type State = OrderedMap<string, Subscription>;

const listToOrderedMap = (list) => {
  return fromJS(list)
    .toOrderedMap()
    .map(Subscription)
    .mapKeys((k, v) => v.get('feedGuid'));
};

const subscriptions = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUBSCRIPTIONS_SUCCESS:
    return listToOrderedMap(payload);
  case ACTIVATE_SUCCESS:
    return state.setIn([payload.feedGuid, 'state'], payload.state);
  default:
    return state;
  }
};

export const loading = (state: boolean = true, action: Action<any>) => {
  switch (action.type) {
  case FETCH_SUBSCRIPTIONS:
  case UNSUBSCRIBE:
    return true;
  case FETCH_SUBSCRIPTIONS_SUCCESS:
  case FETCH_SUBSCRIPTIONS_FAILURE:
  case UNSUBSCRIBE_SUCCESS:
  case UNSUBSCRIBE_FAILURE:
    return false;
  default:
    return state;
  }
};

export default combineReducers({
  subscriptions,
  loading,
});



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/stores.js